import { render, staticRenderFns } from "./FQuickLink.vue?vue&type=template&id=229e90b1&scoped=true"
import script from "./FQuickLink.vue?vue&type=script&lang=js"
export * from "./FQuickLink.vue?vue&type=script&lang=js"
import style0 from "./FQuickLink.vue?vue&type=style&index=0&id=229e90b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e90b1",
  null
  
)

export default component.exports